<template>
  <span>
    <span v-if="has_short">
      <span v-for="(element, index) in label.short" :key="'A' + index">
        <span v-if="element.type == 'katex'" v-katex="element.content"></span>
        <span v-else v-html="element.content"></span>
      </span>
    </span>
    <span v-if="has_short && has_desc"> - </span>
    <span v-if="has_desc">
      <span v-for="(element, index) in label.description" :key="'B' + index">
        <span v-if="element.type == 'katex'" v-katex="element.content"></span>
        <span v-else v-html="element.content"></span>
      </span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'VariableLabelString',
  props: {
    label: { type: Object, required: true },
    has_short: { type: Boolean, default: true },
    has_desc: { type: Boolean, default: true }
  }
}
</script>
